import { render, staticRenderFns } from "./NextOfKinDetails.vue?vue&type=template&id=dbb76c4a&scoped=true"
import script from "./NextOfKinDetails.vue?vue&type=script&lang=js"
export * from "./NextOfKinDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb76c4a",
  null
  
)

export default component.exports